import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Folder } from 'src/app/models/folder';
import { Asset } from 'src/app/models/asset';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { AssetFile } from 'src/app/models/assetFile';
import { AssetComments } from 'src/app/models/assetComments';
import { SortAssetsBy } from 'src/app/models/SortAssetsBy';
import { FolderStructure } from 'src/app/models/FolderStructure';
import { PersonalFilter } from 'src/app/models/PersonalFilter';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  folder2ndround = false;
  folder;
  asset;
  folderRefresh = false;
  // basePath = `http://localhost:52048/api`;
  basePath = "";
  contextmenu;
  contextmenuX;
  contextmenuY;
  newVersionFlag = false;
  newExtensionFlag = false;
  updateAssetFile = false;
  selectedAssetFile: AssetFile = new AssetFile();
  autoLoadTree = false;

  selectedVersionNumber: string;
  assetDetails: any;
  count: number;
  avgRt: number;
  clear3DCache = false;
  dragedAsset: Folder;
  dragedAssetFolder: Folder;
  reloadRating = new Subject<void>();
  previewDuringUpload = false;
  searchResults = new BehaviorSubject({ search: null, folderid: '', searchKey: '', filterKeys: null });
  isFolderCategory = new BehaviorSubject({ isFolder: false });
  folderCategory = this.isFolderCategory.asObservable();
  currentsearchResults = this.searchResults.asObservable();
  uploader: string;
  searchPath = new BehaviorSubject('');
  currentSearchPath = this.searchPath.asObservable();
  fetchAsset = new Subject<string>();

  personalFilter: PersonalFilter;
  personalFilter$ = new Subject<PersonalFilter>();

  isThemeChange = new BehaviorSubject({themeType :'dark'});
  themeChange = this.isThemeChange.asObservable();
  constructor(private http: HttpClient) { }

  async getBasePath() {
    const endpoints = await this.http.get<any>('assets/json/endpoint.json').toPromise();
    this.basePath = endpoints.path;
    return endpoints.path;
  }

  async getEncryptedPassphrase() {
    const encr = await this.http.get<any>('assets/json/encryptedPassphrase.json').toPromise();
    return encr;
  }

  async getFileFormats()
  {
    const response = await this.http.get<any>('assets/json/fileFormats.json').toPromise();
    return response;
  }

  getRootFolderData(userEmailId) {
    return this.http.get<Folder>(`${this.basePath}/folder/folders/${userEmailId}`);
  }

  getFolderById(id) {
    return this.http.get<Folder>(`${this.basePath}/folder/${id}`);
  }

  getFolderByRelativePath(relativePath) {
    return this.http.get<Folder>(`${this.basePath}/folders/${relativePath}`);
  }

  getAssetById(id, userEmailId) {
    return this.http.get<Asset>(`${this.basePath}/asset/${id}/${userEmailId}`);
  }

  // getPreviewImages(id, userEmailId){
  //   const options:any = {
  //     headers: new HttpHeaders({'Content-Type': 'application/zip'}),
  //     responseType:'arraybuffer'
  //   };
  //   return this.http.get(`${this.basePath}/asset/previewImages/${id}/${userEmailId}`,options);
  // }

  addPreviewImages(id, userEmailId, formData) {
    const httpOptions = {
      headers: new HttpHeaders({
        'userEmailId': userEmailId,
      })
    };
    return this.http.put(`${this.basePath}/asset/imagePreview/${id}`, formData, httpOptions);
  }

  addBusinessUnitImage(id, userEmailId, formData) {
    console.log(id);
    const httpOptions: any = {
      headers: new HttpHeaders({ 'userEmailId': userEmailId }),
      responseType: "text"
    };
    return this.http.put(`${this.basePath}/folder/displayImage/${id}`, formData, httpOptions);
  }

  deletePreviewImages(id, userEmailId, path) {
    const options: any = {
      headers: new HttpHeaders({ 'userEmailId': userEmailId }),
      responseType: "text"
    };
    return this.http.delete(`${this.basePath}/asset/imagePreview/${id}/${path}`, options);
  }

  createFolder(folderData, emailId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'userEmailId': emailId
      })
    };
    return this.http.post<Folder>(`${this.basePath}/folder`, folderData, httpOptions);
  }

  modifyFolder(folderData, userEmailId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'userEmailId': userEmailId
      })
    };
    return this.http.put<Folder>(`${this.basePath}/folder/${folderData.FolderId}`, folderData, httpOptions);
  }

  deleteFolder(folderData) {
    const queryParams = {
      userEmailId: folderData.userEmailId,
      parentFolderId: folderData.parentId
    };
    return this.http.delete(`${this.basePath}/folder/${folderData.folderId}`, { params: queryParams });
  }

  uploadFile(url, formData) {
    const req = new HttpRequest('POST', url, formData, {
      reportProgress: true,
    });
    return this.http.request(req);
  }

  updateFile(url, formData) {
    const req = new HttpRequest('PUT', url, formData, {
      reportProgress: true,
    });
    return this.http.request(req);
  }

  download(url) {
    return this.http.get(url, { responseType: 'arraybuffer' });
  }

  search(searchKey) {
    return this.http.get<Folder>(`${this.basePath}/folder/search/${searchKey}`);
  }

  updateAsset(asset, emailId, assetId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'userEmailId': emailId
      })
    };
    return this.http.put<Asset>(`${this.basePath}/asset/${assetId}`, asset, httpOptions);
  }

  addComment(assetId, assetName, comment) {
    return this.http.post(`${this.basePath}/asset/comment/${assetId}/${assetName}`, comment);
  }

  subscribeAsset(assetId, assetName, emailId, isSubscribe) {
    return this.http.post(`${this.basePath}/user/subscribe`, {
      assetId: assetId,
      assetName: assetName,
      emailId: emailId,
      isSubscribe: isSubscribe
    });
  }

  deleteFile(url: string) {
    return this.http.delete(url);
  }

  fetchFiles(url: string): Observable<Array<string>> {
    return this.http.get<Array<string>>(url);
  }

  getPersonalBrowserStructure() {
    return this.http.get<Folder>(`${this.basePath}/folder/personalBrowser`);
  }

  getPersonalBrowser(userEmailId: string, id = 'all') {
    return this.http.get<Folder>(`${this.basePath}/folder/personalBrowser/${userEmailId}/${id}`);
  }

  downloadAssetBundle(id: string, userEmailId: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'userEmailId': userEmailId
      }),
      responseType: "arraybuffer"
    };

    return this.http.get(`${this.basePath}/assetFile/${id}`,
      { headers: new HttpHeaders({ 'userEmailId': userEmailId }), responseType: "arraybuffer" });
  }

  downloadPrivilegedFiles(id: string, userEmailId: string)
  {
    const httpOptions = {
      headers: new HttpHeaders({
        'userEmailId': userEmailId
      }),
      responseType: "arraybuffer"
    };
    return this.http.get(`${this.basePath}/asset/privilegedFile/${id}`,
      { headers: new HttpHeaders({ 'userEmailId': userEmailId }), responseType: "arraybuffer" });
  }
  addAssetDownload(userEmailId, assetId) {
    return this.http.post(`${this.basePath}/user/addAssetDownload/${userEmailId}/${assetId}`, null);
  }

  deleteAsset(assetId, folderId, userEmailId) {
    return this.http.delete(`${this.basePath}/asset/${folderId}/${assetId}/${userEmailId}`);
  }

  renameAsset(assetName, assetId, folderId, userEmailId) {
    const obj = {
      assetBundelId: assetId,
      newAssetName: assetName,
      parentFolderId: folderId
    }
    return this.http.put(`${this.basePath}/asset/rename/${userEmailId}`, obj);
  }

  deleteComment(assetId: string, assetName: string, commentId: string, userEmailId: string) {
    return this.http.delete(`${this.basePath}/asset/comment/${assetId}/${assetName}/${commentId}/${userEmailId}`);
  }

  updateComment(comment: AssetComments, asset_id: string, assetName: string) {
    return this.http.put(`${this.basePath}/asset/comment/${asset_id}/${assetName}`, comment);
  }

  moveAsset(assetId: string, folderId: string, userEmailId: string) {
    return this.http.put(`${this.basePath}/asset/move/${assetId}/${folderId}/${userEmailId}`, null);
  }

  getAssetCardDetails(assets: Array<string>, userEmailId: string) {
    return this.http.post(`${this.basePath}/asset/assetCardDetails/${userEmailId}`, assets);
  }

  deleteAssetVersion(assetId: string, version: string, userEmailId: string) {
    return this.http.delete(`${this.basePath}/asset/deleteVersion/${assetId}/${version}/${userEmailId}`);
  }

  searchFolderAssets(searchKey, userEmailId) {
    let searchText = !searchKey || searchKey == '' ? ' ' : searchKey;
    return this.http.get<Folder>(`${this.basePath}/folder/searchFolderAssets/${searchText}/${userEmailId}`);
  }

  uploadNewAssetFile(url, formData) {
    return this.http.put(url, formData);
  }

  getLibraryFolderStructure(id, userEmailId) {
    return this.http.get<Folder>(`${this.basePath}/folder/libraryFolderStructure/${id}/${userEmailId}`);
  }

  getHomePageAssets(userEmailId) {
    return this.http.get(`${this.basePath}/home/gethomecontent/${userEmailId}`);
  }

  sortAssets(searchKey: string, userEmailId: string, sortAssetsBy: SortAssetsBy, parentFolderId: string = '', filterParamForSort: any) {
    let searchText = !searchKey || searchKey == '' ? ' ' : searchKey;
    return this.http.post(`${this.basePath}/folder/searchAssets/sort/${searchText}/${userEmailId}/${sortAssetsBy}/${parentFolderId}`, filterParamForSort);
  }

  searchAssets(searchKey: string, userEmailId, folderId: string = '') {
    let searchText = !searchKey || searchKey == '' ? ' ' : searchKey;
    return this.http.get<Folder>(`${this.basePath}/folder/searchAssets/${searchText}/${userEmailId}/${folderId}`);
  }

  changesearchResults(search, folderid, searchKey, filterKeys) {
    if (searchKey === null) {
      searchKey = '';
    }
    this.searchResults.next({ search, folderid, searchKey, filterKeys });
  }

  changeFolderFlag(isFolder) {
    this.isFolderCategory.next({ isFolder });
  }

  changeThemeFlag(themeType){
    this.isThemeChange.next({themeType});
  }

  applyFilters(searchKey, userEmailId, folderId, filterSelectionValues) {
    let searchText = !searchKey || searchKey == '' ? ' ' : searchKey;
    return this.http.post(`${this.basePath}/folder/searchAssets/filter/${searchText}/${userEmailId}/${folderId}`, filterSelectionValues);
  }

  saveFilters(filter, userId) {
    return this.http.post(`${this.basePath}/folder/filter/${userId}`, filter);
  }

  fetchFilters(userId) {
    this.http.get(`${this.basePath}/folder/filter/${userId}`).subscribe((result) => {
      this.personalFilter = JSON.parse(JSON.stringify(result));
      this.personalFilter$.next(this.personalFilter);
    }, (err) => {
      console.log(err);
    });
  }

  deleteFilter(filterName, userId) {
    return this.http.delete(`${this.basePath}/folder/filter/${userId}/${filterName}`, { responseType: 'text' });
  }

  renameFilter(filterName, userId, updatedFilter) {
    return this.http.put(`${this.basePath}/folder/filter/${userId}/${filterName}`, updatedFilter, { responseType: 'text' });
  }

  populateAllFilters(): Observable<any> {
    return this.personalFilter$.asObservable();
  }

  changePath(path) {
    this.searchPath.next(path);
  }

  requestSecretKey(userEmailId: string, applicationId: string) {
    return this.http.get(`${this.basePath}/user/generateSecretKey/${applicationId}`, { headers: new HttpHeaders({ 'userEmailId': userEmailId }) });
  }

  viewSecretKey(userEmailId: string, applicationId: string) {
    return this.http.get(`${this.basePath}/user/viewSecretKey/${applicationId}`,{ headers: new HttpHeaders({ 'userEmailId': userEmailId }) });
  }

  getAllFolders(userEmailId: string) {
    return this.http.get<Array<FolderStructure>>(`${this.basePath}/allfolders/${userEmailId}`);
  }

  getParentFolderthroughRelativepath(relativePath: string) {
    return this.http.get<Array<FolderStructure>>(`${this.basePath}/folders/${relativePath}`);
  }

  executeApiTestGetRequest(url: string, header: any) {
    return this.http.get(url, { headers: header });
  }

  executeApiTestPostWithRawBody(url: string, body: any, header: any) {
    if (header != null)
      return this.http.post(url, body, { headers: header });
    else
      return this.http.post(url, body);
  }

  executeApiTestPostWithFormData(url: string, formData: FormData, header: any) {
    return this.http.post(url, formData, { headers: header });
  }

  executeApiTestPutWithFormData(url: string, formData: FormData, header: any) {
    return this.http.put(url, formData, { headers: header });
  }

  executeApiTestPutWithRawData(url: string, body: any, header: any) {
    return this.http.put(url, body, { headers: header });
  }

  executeApiTestDelete(url: string, header: any) {
    return this.http.delete(url, { headers: header });
  }
  fetchFaq(userEmailId: string) {
    return this.http.get<Array<FolderStructure>>(`${this.basePath}/user/faq/${userEmailId}`);
  }

  getAccessToken(tokenRequest, userEmailId) {
    const options: any = {
      headers: new HttpHeaders({ 'userEmailId': userEmailId }),
    };
    return this.http.post(`${this.basePath}/user/getAccessToken`, tokenRequest, options);
  }
}
